import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BluetoothDriveIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bluetooth_drive"}/>
}
